import "./css/custom.css";
import React  from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import Toast from "./components/actionNotice";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./components/Loader";
import { mainPageSchema } from "./utils/seo-schemas";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { getPublicPath } from "./utils";
import { useUserData } from "./hooks/useUserData";

const Questions = React.lazy(() => import("@/pages/questions"));
const Login = React.lazy(() => import("@/pages/login"));
const ForgotPassword = React.lazy(() => import("@/pages/forgot-password"));
const StudentDashboard = React.lazy(() => import("@/pages/dashboard"));
const Signup = React.lazy(() => import("@/pages/signup"));
const ThankYou = React.lazy(() => import("@/pages/thank-you"));

export const AppRouter = () => {
  const { userData } = useUserData();
  console.log("User Data:", userData);

  const publicPath = getPublicPath();

  return (
    <Router {...(publicPath ? { basename: `/${publicPath}` } : {})}>
      <div className="app-container">
        <Helmet>
          <meta charSet="utf-8" />
          <title>EduPrepMe: Free AI-Powered SAT Practice Tests</title>
          <meta
            name="description"
            content="Boost your SAT score with free, unlimited, AI-personalized tests. Study smarter and achieve success—join now!"
          />
          <script type="application/ld+json">
            {JSON.stringify(mainPageSchema)}
          </script>
          <meta property="og:site_name" content="Eduprepme" />
          <meta property="og:locale" content="en_US" />
          <meta
            property="og:image"
            content="https://www.eduprepme.com/img/logo.png"
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="EduPrepMe: Free AI-Powered SAT Practice Tests"
          />
          <meta
            property="og:description"
            content="Boost your SAT score with free, unlimited, AI-personalized tests. Study smarter and achieve success—join now!"
          />
          <meta property="og:url" content="https://eduprepme.com" />
        </Helmet>
        <div className="main-content">
          <div className="content">
            <Toast />
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route
                path="/login"
                element={
                  !userData.isLoggedIn ? (
                    <React.Suspense fallback={Loader}>
                      <Login />
                    </React.Suspense>
                  ) : (
                    <Navigate to="/dashboard" />
                  )
                }
              />
              <Route
                path="/signup"
                element={
                  !userData.isLoggedIn ? (
                    <React.Suspense fallback={Loader}>
                      <Signup />
                    </React.Suspense>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/thankyou"
                element={
                  <React.Suspense fallback={Loader}>
                    <ThankYou />
                  </React.Suspense>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <React.Suspense fallback={Loader}>
                    <ForgotPassword />
                  </React.Suspense>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <React.Suspense fallback={Loader}>
                    <StudentDashboard />
                  </React.Suspense>
                }
              />
              <Route
                path="/questions"
                element={
                  <React.Suspense fallback={Loader}>
                    <Questions />
                  </React.Suspense>
                }
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};
